// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"16d6a707","453":"3a92a6b3","918":"931bbbf9"}[chunkId] + ".chunk.js";
};